import { useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { useSelector } from 'react-redux';
import { EditUser } from "./EditUser";

export const UserTable = () => {
  const { role } = useSelector((state) => state.auth);
  const { usersList } = useSelector((state) => state.catalogue);
  const [edit, setEdit] = useState(false)
  const [item, setItem] = useState({});

  const edit2 = (item) => {
    setEdit(true);
    setItem(item)
  }

  const columns = [
    {
      name: "Nombre",
      selector: row => [row.name],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.name}</span>
    },
    {
      name: "Usuario",
      selector: row => [row.userName],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.userName}</span>
    },
    {
      name: "Rol",
      selector: row => [row.role],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.role}</span>
    },   
    {
      name: "Comision %",
      selector: row => [row.fee],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.fee}</span>
    },    
    {
      name: "Estatus",
      selector: row => [row.status],
      sortable: true,
      cell: row => <span className="text-muted fs-15 fw-semibold">{row.status === 1 ? "Activo" : "Inactivo"}</span>
    },
    {
      name: "Editar",
      width: "85px",
      cell: row => <span className="text-center w-100">
        {
          role == "DIRECTOR" &&
          <i className={`fe fe-edit .hover`} role='button' onClick={() => edit2(row)}></i>
        }        
      </span>
    },
  ]
  const tableDatas = {
    columns,
    data: usersList,
  };
  return (
    <>
      <DataTableExtensions {...tableDatas} >
        <DataTable
          columns={columns}
          data={usersList}
          noHeader
          defaultSortField="id"
          defaultSortAsc={false}
          striped={true}
          center={true}
          persistTableHead
          pagination
          highlightOnHover />
      </DataTableExtensions>
      <EditUser item={item} isOpen={edit} setIsOpen={setEdit} />
    </>
  )
}